<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      :dark="dark"
    >
      <v-toolbar :dark="dark" color="primary">
        <v-btn icon :dark="dark" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title
          v-if="selectedRoom.name"
        >Rediger {{selectedRoom.type.name}} ({{selectedRoom.name}})</v-toolbar-title>
        <v-toolbar-title v-else-if="selectedRoom.type">Rediger {{selectedRoom.type.name}}</v-toolbar-title>
        <v-toolbar-title v-else>Nytt rom</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-flex xs12>
            <v-select
              label="Romtype"
              v-model="selectedRoomType"
              :items="roomTypeList"
              :append-outer-icon="selectedRoomType.icon"
            >
              <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
              <template slot="item" slot-scope="data">{{ data.item.name }}</template>
            </v-select>
          </v-flex>
          <v-flex xs12 class="mb-5">
            <v-text-field solo label="Navn på rom" clearable v-model="selectedRoom.name"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="selectedRoom.type">
            <v-tabs centered color="info" v-model="active_tab" :dark="dark" icons-and-text>
              <v-tabs-slider color="info darken-4"></v-tabs-slider>

              <v-tab href="#tab-condition">
                Tilstand
                <v-icon>mdi-wrench</v-icon>
              </v-tab>

              <v-tab href="#tab-cleaning" v-if="cleaningEnabled">
                Vask
                <v-icon>mdi-spray-bottle</v-icon>
              </v-tab>

              <v-tab href="#tab-pictures">
                {{ imagesTitle }}
                <v-icon>mdi-camera</v-icon>
              </v-tab>
              <v-tabs-items touchless>
                <v-tab-item value="tab-condition">
                  <v-card flat>
                    <v-card-text class="pr-0 pl-0">
                      <h4>Tilstandsrapport:</h4>
                      <BooleanInputTable
                        objectTitle="Objekt"
                        boolTitle="Uten avvik?"
                        :commentTitle="stateCommentTitle"
                        v-model="selectedRoom.type.stateQuestions.questions"
                        @update-fields="updateMessage"
                        :showFixing="true"
                      ></BooleanInputTable>
                      <div class="text-right mb-4">
                        <v-btn
                          v-if="cleaningEnabled"
                          fab
                          :dark="dark"
                          color="info"
                          @click="active_tab = 'tab-cleaning'"
                        >
                          <v-icon :dark="dark">mdi-spray-bottle</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          fab
                          :dark="dark"
                          color="info"
                          @click="active_tab = 'tab-pictures'"
                        >
                          <v-icon :dark="dark">mdi-camera</v-icon>
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-cleaning" v-if="cleaningEnabled">
                  <v-card flat>
                    <v-card-text class="pr-0 pl-0">
                      <h4>Vask:</h4>
                      <BooleanInputTable
                        objectTitle="Område"
                        boolTitle="Godkjent?"
                        commentTitle="Kommentar"
                        v-model="selectedRoom.type.cleanQuestions.questions"
                        @update-fields="updateMessage"
                      ></BooleanInputTable>
                      <v-layout row class="mb-4">
                        <v-flex xs6 class="text-left">
                          <v-btn
                            fab
                            :dark="dark"
                            color="info"
                            @click="active_tab = 'tab-condition'"
                          >
                            <v-icon :dark="dark">mdi-wrench</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 class="text-right">
                          <v-btn fab :dark="dark" color="info" @click="active_tab = 'tab-pictures'">
                            <v-icon :dark="dark">mdi-camera</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-pictures">
                  <ImageUploadBox
                    :images="selectedRoom.images"
                    :relatedImages="selectedRoom.relatedImages"
                    :title="imagesTitle"
                  ></ImageUploadBox>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-flex>
        </v-card-text>
        <v-footer color="white" fixed class="pt-2 pb-2">
          <v-flex text-xs-center>
            <v-btn color="success" block @click="closeDialog">Lagre / lukk</v-btn>
          </v-flex>
        </v-footer>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import ROOMTYPES from "../../../models/roomTypes";
import RoomTypeFactory from "../../../models/roomTypeFactory";
import BooleanInputTable from "../../form/BooleanInputTable.vue";
import ImageUploadBox from "../../upload/ImageUploadBox.vue";

export default {
  data() {
    return {
      active_tab: "tab-condition",
      roomTypes: ROOMTYPES,
      imageDialog: false,
      selectedImage: { comment: "" }
    };
  },
  components: { BooleanInputTable, ImageUploadBox },
  props: ["dialog", "selectedRoom", "cleaningEnabled", "config"],
  mounted: function() {},
  methods: {
    updateMessage(e) {
      this.$emit("update-fields");
    },
    addNewRoom() {
      this.$emit("add-room", this);
    },
    closeDialog() {
      if(this.config.imageCommentRequired) {
        for(let image in this.selectedRoom.images) {
          if(!this.selectedRoom.images[image].comment) {
            this.$emit("error", "Alle bilder av avvik må kommenteres")
            return false
          }
        }
      }
      if(this.config.stateStatusRequired) {
        for(let question in this.selectedRoom.type.stateQuestions.questions) {
          if(this.selectedRoom.type.stateQuestions.questions[question].value == -1) {
            this.$emit("error", "For å sette dette rommet som fullført, vennligst besvar alle spørsmål om tilstand")
            this.$emit("close-edit-room-dialog", false);
            return false
          }
        }
      }
      this.selectedRoom.active_tab = this.active_tab;
      this.$emit("close-edit-room-dialog", true);
    },
    openImageDialog(image) {
      this.selectedImage = image;
      this.imageDialog = true;
    },
    addNewImage(image) {
      this.selectedRoom.images.push(image);
    },
    deleteImage(i) {
      this.selectedRoom.images.splice(i, 1);
    }
  },
  computed: {
    roomTypeList: {
      get() {
        let arr = [];
        for (var propertyName in this.roomTypes) {
          let rType = RoomTypeFactory.createInstance(propertyName);
          if (this.selectedRoom.type.name == rType.name) {
            arr.push(this.selectedRoom.type);
          } else {
            arr.push(rType);
          }
        }
        return arr;
      }
    },
    selectedRoomType: {
      get() {
        return this.selectedRoom.type;
      },
      set(type) {
        this.selectedRoom.type = RoomTypeFactory.createInstance(type.id);
      }
    },
    dark: {
      get() {
        if (this.$store.state.protocol.dark) {
          return this.$store.state.protocol.dark;
        }
        return false;
      }            
    },
    stateCommentTitle: function() {
      if (this.config.stateCommentTitle) {
        return this.config.stateCommentTitle;
      }
      return "Kommentar/tilstand";
    },
    imagesTitle: function() {
      if (this.config.imagesTitle) {
        return this.config.imagesTitle;
      }
      return "Bilder avvik";
    }    
  },
  watch: {
    selectedRoom: function(newVal, oldVal) {
      // watch it
      newVal.edited = true;
      if (
        typeof newVal.active_tab !== "undefined" ||
        newVal.active_tab !== null
      ) {
        this.active_tab = newVal.active_tab;
      } else {
        this.active_tab = "tab-condition";
      }
    }
  }
};
</script>

<style>
a:hover {
  text-decoration: none;
  color: #fff;
}
.cld-image img {
  width: 100%;
  height: auto;
}
</style>